import Vue from 'vue'
import VueRouter from 'vue-router'
import { qrMap } from '../utils'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/share/:hash',
    name: 'Share',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  { path: '/qr/:id?',    
    redirect: to => {
      // const { hash, params, query } = to

      // if (query.qr === 'astoria') {
      //   return { path: '/', name: 'Home', hash: '#YTd8czF8dDd8bzZ3fHIxfGk4fGExMF9tb2Rlcm5fYmxhY2tfbWF0LWdyZXk=', query: null } // astoria
      // }
      // if (hash === '#baz') {
      //   return { path: '/', name: 'Home', hash: '#YjR8bDR8YTR8aDF3fGExNV9tb2Rlcm5fYmxhY2tfbWF0LWdyZXk=' } // blaha
      // }
      // if(params.id == 'ig'){
      //   //window.location.href = "https://google.com/contact"
      //   return null
      // }
        
      // TODO maybe replace this shit with worker redirect so the whole page will not be loaded here just to redirect... (only makes sense if there will be lots of external redirects)  
      if(to.params.id == 'ig' || to.params.id == 'sziget'){  // TODO este átírni randomizálni néha maradjon siteon néha vigyen instára?        
        Vue.prototype.$appInsights.trackEvent({name: "QR", properties: {code: to.params.id}})
        Vue.prototype.$appInsights.flush(false)   
        //console.log('here comes the redirect...')
        window.location.replace('https://www.instagram.com/cityphography');      
        //window.location.href = "intent://instagram.com/_u/cityphography/#Intent;package=com.instagram.android;scheme=https;end" // sadly deep linking doesn't work if the link is a redirect or non-user initiated (aka from script)
        return null 
      }
      let qr = qrMap.find(q => q.id == to.params.id)
      if(qr){
        Vue.prototype.$appInsights.trackEvent({name: "QR", properties: {code: qr.id}})
        return { path: `/share/${qr.hash.substring(1)}`/*, name: 'Share'/*, hash: qr.hash*/ }       
      }  
      return { path: '/', name: 'Home' }      
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/prints',
    name: 'Prints',
    component: () => import(/* webpackChunkName: "prints" */ '../views/Prints.vue')
  },
  {
    path: '/legal',
    name: 'Legal',
    component: () => import(/* webpackChunkName: "legal" */ '../views/Legal.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue')
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import(/* webpackChunkName: "cart" */ '../views/StripeCart.vue')
  }//,
  // {
  //   path: '/stripecart',
  //   name: 'StripeCart',
  //   component: () => import(/* webpackChunkName: "stripecart" */ '../views/StripeCart.vue')
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // scrollBehavior(to/*, from, savedPosition*/) {
  //   //return { x: 0, y: 0 }
  //   if (to.hash) {     
  //     return {selector: to.hash}  // this shit does not work
  //   } 
  //   else {
  //       return { x: 0, y: 0 }
  //   }
  // }
})

export default router
